import cc from 'classcat';
import { capitalizeFirst } from 'ramda-extension';

import BaseCtaButton from '#src/components/CtaButton';

import styles from './CtaButton.scss';

export default function CtaButton({ className, ...props }) {
  const { variant } = props?.cta?.fields || {};

  return (
    <BaseCtaButton
      className={cc([
        styles.ctaButton,
        styles[`variant${capitalizeFirst(variant)}`],
        className,
      ])}
      {...props}
    />
  );
}
